import React, { useCallback, useEffect, useState, useMemo } from "react";
import ReactFlow, {
  Background,
  Controls,
  MiniMap,
  useNodesState,
  useEdgesState,
  addEdge,
  Panel,
  Handle,
  Position,
  ReactFlowProvider,
  Node,
  Edge,
} from "reactflow";
import "reactflow/dist/style.css";
import axios from "axios";
import { Alert, Spinner, Button } from "react-bootstrap";
import { FaTriangleExclamation, FaWifi } from "react-icons/fa6";
import { MdRefresh } from "react-icons/md";

// TypeScript interfaces

interface Props {
  name: string;
  age: number;
  type: string,
}
interface ColumnData {
  key: string;
  name: string;
  type: string;
  iconShow: string;
  x: number;
  y: number;
}

interface Relation {
  source: ColumnData;
  target: ColumnData;
}

interface MappingData {
  //_id: string;
  schema: string;
  relations: Relation[];
}

interface TableNodeData {
  title: string;
  columns: ColumnData[];
  isLeftTable?: boolean;
}

interface CustomTableNodeProps {
  data: TableNodeData;
}

interface ErrorState {
  message: string;
  type: 'connection' | 'server' | 'notfound' | 'auth' | 'validation' | 'general';
  originalError?: any;
}

console.log(localStorage.getItem("url1"));

console.log(localStorage.getItem("url2"));

var url1 = localStorage.getItem("url1");

var url2 = localStorage.getItem("url2");

// Configuration object
const CONFIG = {
  COLORS: {
    accent: "#00bfff",
    background: "#1a1a1a",
    border: "#333",
    text: "#ffffff",
    subtext: "#666666",
  },
  SIZES: {
    nodeWidth: "280px",
    handleSize: "8px",
  },
  API: {
    sourceTableEndpoint: localStorage.getItem("url1"),
    targetTableEndpoint: localStorage.getItem("url2"),
    smartMappingEndpoint: localStorage.getItem("url3"),
  },
};

// Synthetic data for API responses
const MOCK_SOURCE_TABLE: string[] = ["Name", "Description", "Postal Code"];
const MOCK_TARGET_TABLE: string[] = ["Full Name", "Details", "Zip Code"];

const SYNTHETIC_MAPPING_DATA: MappingData = {
  //_id: "678bf567419b3276f29fee2a",
  schema: "GDSN.csv",
  relations: [
    {
      source: {
        key: "Name",
        name: "Name",
        iconShow: "inherit",
        type: "String",
        x: 207,
        y: 89,
      },
      target: {
        key: "Brand",
        name: "Brand",
        type: "String",
        iconShow: "inherit",
        x: 383,
        y: 9161,
      },
    },
    {
      source: {
        key: "Description",
        name: "Description",
        iconShow: "inherit",
        type: "String",
        x: 210,
        y: 120,
      },
      target: {
        key: "Details",
        name: "Details",
        type: "String",
        iconShow: "inherit",
        x: 385,
        y: 9200,
      },
    },
    {
      source: {
        key: "Postal Code",
        name: "Postal Code",
        iconShow: "inherit",
        type: "String",
        x: 215,
        y: 150,
      },
      target: {
        key: "Zip Code",
        name: "Zip Code",
        type: "String",
        iconShow: "inherit",
        x: 390,
        y: 9250,
      },
    },
  ],
};

// API Service

const ApiService = {
  fetchSourceTable: async (): Promise<string[]> => {
    try {
      const response = await fetch(CONFIG.API.sourceTableEndpoint);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const columnNames =
        data.columns?.map((col: any) => col.name || col) || data;

      if (!Array.isArray(columnNames))
        throw new Error("Invalid data format received from API");

      return columnNames;
    } catch (error: any) {
      console.error("Error fetching source table:", error);

      // Enhanced error handling
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        throw new Error('ERR_CONNECTION_REFUSED');
      } else if (error.message.includes('HTTP error! Status: 404')) {
        throw new Error('Source table service not found');
      } else if (error.message.includes('HTTP error! Status: 5')) {
        throw new Error('Server error occurred while loading source table');
      } else if (error.message.includes('HTTP error! Status: 401') || error.message.includes('HTTP error! Status: 403')) {
        throw new Error('Access denied for source table');
      }

      throw error;
    }
  },
  fetchTargetTable: async (): Promise<string[]> => {
    try {
      const response = await fetch(CONFIG.API.targetTableEndpoint);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const columnNames =
        data.columns?.map((col: any) => col.name || col) || data;

      if (!Array.isArray(columnNames))
        throw new Error("Invalid data format received from API");

      return columnNames;
    } catch (error: any) {
      console.error("Error fetching target table:", error);

      // Enhanced error handling
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        throw new Error('ERR_CONNECTION_REFUSED');
      } else if (error.message.includes('HTTP error! Status: 404')) {
        throw new Error('Target table service not found');
      } else if (error.message.includes('HTTP error! Status: 5')) {
        throw new Error('Server error occurred while loading target table');
      } else if (error.message.includes('HTTP error! Status: 401') || error.message.includes('HTTP error! Status: 403')) {
        throw new Error('Access denied for target table');
      }

      throw error;
    }
  },
  fetchSmartMapping: async (): Promise<MappingData> => {
    try {
      console.log(CONFIG.API.smartMappingEndpoint);

      const response = await fetch(localStorage.getItem("url3") || '');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = (await response.json()) as MappingData;
      return data;
    } catch (error: any) {
      console.error("Error fetching smart mapping:", error);

      // Enhanced error handling
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        throw new Error('ERR_CONNECTION_REFUSED');
      } else if (error.message.includes('HTTP error! status: 404')) {
        throw new Error('Smart mapping service not found');
      } else if (error.message.includes('HTTP error! status: 5')) {
        throw new Error('Server error occurred during smart mapping');
      } else if (error.message.includes('HTTP error! status: 401') || error.message.includes('HTTP error! status: 403')) {
        throw new Error('Access denied for smart mapping');
      }

      throw error;
    }

    // return new Promise((resolve) => {
    //   setTimeout(() => resolve(SYNTHETIC_MAPPING_DATA), 1500);
    // });
  },
};

// Custom node component
const CustomTableNode: React.FC<CustomTableNodeProps> = ({ data }) => {
  if (!data?.title || !data?.columns) {
    console.error("Missing required props in CustomTableNode");
    return null;
  }

  return (
    <div
      style={{
        background: CONFIG.COLORS.background,
        border: `2px solid ${CONFIG.COLORS.accent}`,
        borderRadius: "8px",
        padding: "0",
        minWidth: CONFIG.SIZES.nodeWidth,
        boxShadow: `0 0 10px rgba(0, 191, 255, 0.2)`,
      }}
    >
      <div
        style={{
          background: "#2a2a2a",
          padding: "12px 16px",
          borderTopLeftRadius: "6px",
          borderTopRightRadius: "6px",
          borderBottom: `1px solid ${CONFIG.COLORS.accent}`,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span
          style={{
            color: CONFIG.COLORS.text,
            fontSize: "16px",
            fontWeight: "500",
          }}
        >
          {data.title}
        </span>
        <span
          style={{
            color: CONFIG.COLORS.accent,
            fontSize: "12px",
            opacity: 0.8,
          }}
        >
          {data.isLeftTable ? "SOURCE" : "TARGET"}
        </span>
      </div>

      <div style={{ padding: "12px 0" }}>
        {data.columns.map((col, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "8px 16px",
              borderLeft: "2px solid transparent",
              transition: "all 0.2s ease",
              position: "relative",
            }}
          >
            {data.isLeftTable ? (
              <Handle
                type="source"
                position={Position.Right}
                id={`${col.key}-source`}
                style={{
                  background: CONFIG.COLORS.accent,
                  width: CONFIG.SIZES.handleSize,
                  height: CONFIG.SIZES.handleSize,
                  right: "-4px",
                  border: "none",
                }}
              />
            ) : (
              <Handle
                type="target"
                position={Position.Left}
                id={`${col.key}-target`}
                style={{
                  background: CONFIG.COLORS.accent,
                  width: CONFIG.SIZES.handleSize,
                  height: CONFIG.SIZES.handleSize,
                  left: "-4px",
                  border: "none",
                }}
              />
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
              }}
            >
              <span style={{ color: CONFIG.COLORS.accent }}>{col.name}</span>
              <span
                style={{
                  color: CONFIG.COLORS.subtext,
                  fontSize: "12px",
                  marginLeft: "8px",
                }}
              >
                {col.type}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};



const Flow: React.FC<Props> = ({ name, type, age }) => {
 
  console.log(name)
  console.log(type);

  
 
  const [count, setCount] = useState(0);

  const refreshComponent = () => {
    setCount(count + 1); // Updating state triggers re-render
  };

  //refreshComponent();

  var tuid = localStorage.getItem("tuid");
  var uuid = localStorage.getItem("uuid");
  localStorage.setItem(
    "url1",
    "http://localhost:5050/api/get_source_fields/" + tuid
  );
  localStorage.setItem(
    "url2",
    "http://localhost:5050/api/get_schema_fields/" + uuid
  );

  const baseURLUpdateJobs2 = "http://127.0.0.1:5050/api/update_job2";

   const baseURLUpdateJobs1 = "http://127.0.0.1:5050/api/update_job";


  //console.log(CONFIG.API.targetTableEndpoint);
  //CONFIG.API.targetTableEndpoint = url1;
  //console.log(CONFIG.API.targetTableEndpoint);

  //console.log(CONFIG.API.sourceTableEndpoint);
  //sCONFIG.API.sourceTableEndpoint = url2;
  //console.log(CONFIG.API.sourceTableEndpoint);

  const [loading, setLoading] = useState<boolean>(false);
  const [smartMappingLoading, setSmartMappingLoading] =
    useState<boolean>(false);
  const [error, setError] = useState<ErrorState | null>(null);
  const [smartMappingError, setSmartMappingError] = useState<ErrorState | null>(null);
  const [saveError, setSaveError] = useState<ErrorState | null>(null);
  const [showDeleteHint, setShowDeleteHint] = useState(true);
  const [sourceTableData, setSourceTableData] = useState<string[]>([]);
  const [targetTableData, setTargetTableData] = useState<string[]>([]);

  // Helper function to create error objects
  const createErrorState = (err: any): ErrorState => {
    let errorMessage = 'An unexpected error occurred. Please try again.';
    let errorType: ErrorState['type'] = 'general';

    if (err.message === 'ERR_CONNECTION_REFUSED' || err.message.includes('Failed to fetch')) {
      errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
      errorType = 'connection';
    } else if (err.message.includes('not found')) {
      errorMessage = err.message + '. Please contact support.';
      errorType = 'notfound';
    } else if (err.message.includes('Server error')) {
      errorMessage = err.message + '. Please try again later.';
      errorType = 'server';
    } else if (err.message.includes('Access denied')) {
      errorMessage = err.message + '. Please check your permissions.';
      errorType = 'auth';
    } else if (err.message.includes('Invalid data format')) {
      errorMessage = err.message + '. Please contact support.';
      errorType = 'validation';
    } else if (err.message) {
      errorMessage = err.message;
    }

    return { message: errorMessage, type: errorType, originalError: err };
  };

  // Memoize nodeTypes to prevent recreation on each render
  const nodeTypes = useMemo(
    () => ({
      customTable: CustomTableNode,
    }),
    []
  );

  // Convert string array to ColumnData array
  const convertToColumnData = (
    data: string[],
    isSource: boolean
  ): ColumnData[] => {
    return data.map((item, index) => ({
      key: item,
      name: item,
      type: "String",
      iconShow: "inherit",
      x: isSource ? 200 : 400,
      y: 50 + index * 30,
    }));
  };

  // Create initial nodes from source and target data
  const createInitialNodes = (
    sourceData: string[],
    targetData: string[]
  ): Node[] => {
    const sourceColumns = convertToColumnData(sourceData, true);
    const targetColumns = convertToColumnData(targetData, false);

    return [
      {
        id: "source",
        type: "customTable",
        position: { x: 100, y: 90 },
        data: {
          title: "Source Table",
          columns: sourceColumns,
          isLeftTable: true,
        },
      },
      {
        id: "target",
        type: "customTable",
        position: { x: 950, y: 90 },
        data: {
          title: "Target Table",
          columns: targetColumns,
          isLeftTable: false,
        },
      },
    ];
  };

  // Create edges from mapping data
  const createEdgesFromMapping = (mappingData: MappingData): Edge[] => {
    console.log("createEdgesFromMapping");
    console.log(mappingData);

    return mappingData.relations.map((relation, index) => ({
      id: `edge-${index}`,
      source: "source",
      target: "target",
      sourceHandle: `${relation.source.key}-source`,
      targetHandle: `${relation.target.key}-target`,
      animated: true,
    }));
  };

  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);

  useEffect(() => {
    // Update API endpoints when props change
    localStorage.setItem(
      "url1",
      "http://localhost:5050/api/get_source_fields/" + tuid
    );
    localStorage.setItem(
      "url2",
      "http://localhost:5050/api/get_schema_fields/" + uuid
    );
    localStorage.setItem(
      "url3",
      "http://localhost:5050/api/SmartMapping/" + type
    );
    
    // Trigger a refresh after updating URLs
    refreshComponent();
  }, [tuid, uuid, type])

  // Fetch source and target table data on mount
  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const sourceData = await ApiService.fetchSourceTable();
      const targetData = await ApiService.fetchTargetTable();
      setSourceTableData(sourceData);
      setTargetTableData(targetData);
      setNodes(createInitialNodes(sourceData, targetData));
    } catch (err: any) {
      console.error("Error fetching table data:", err);
      setError(createErrorState(err));
    } finally {
      setLoading(false);
    }
  }, [name, type, count]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Handle edge connection
  const onConnect = useCallback(
    (params: any) => setEdges((eds) => addEdge(params, eds)),
    [setEdges]
  );

  // Handle edge deletion
  const onEdgeClick = useCallback(
    (event: React.MouseEvent, edge: Edge) => {
      const isConfirmed = window.confirm(
        "Do you want to delete this connection?"
      );
      if (isConfirmed) {
        setEdges((eds) => eds.filter((e) => e.id !== edge.id));
      }
    },
    [setEdges]
  );

  // Handle save mappings
  const handleSubmit = async () => {
    setSaveError(null);
    try {
    const mappings = edges.map((edge) => ({
      source: edge.sourceHandle?.replace("-source", ""),
      target: edge.targetHandle?.replace("-target", ""),
    }));
    //console.log("Current mappings:", mappings);
    //console.log(typeof mappings);

    //console.log(JSON.stringify(mappings))

    const user_name = localStorage.getItem("userInfo");

    const obj = JSON.parse(user_name);
    console.log(obj.userFound.email);

    const schema_filename = localStorage.getItem("schefile");
    console.log(schema_filename);

    const tfile = localStorage.getItem("manufile");
    console.log(tfile);

    const tuid = localStorage.getItem("tuid");
    console.log(tuid);

    console.log(sourceTableData);
    console.log(targetTableData);

    localStorage.setItem(
      "url3",
      "http://localhost:5050/api/SmartMapping/" + type
    );

      await axios.post(
        "http://localhost:5050/api/save_mappings" + "/" + type,
        JSON.stringify(mappings),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    console.log(mappings);

    let json = {
      relation: mappings,
      schemas: targetTableData,
      sfile: schema_filename,
    };
    let jsonString = JSON.stringify(json);

    console.log(type)

      if(type === 'multiple') {
        const response = await fetch(
          baseURLUpdateJobs2 + "/" + tuid + "/" + tfile + "/" + obj.userFound.email,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            method: "POST",
            body: jsonString,
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        await response.json();
      } else {
        const response = await fetch(
          baseURLUpdateJobs1 +
            "/" +
            tuid +
            "/" +
            tfile +
            "/" +
            obj.userFound.email,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            method: "POST",
            body: jsonString,
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        await response.json();
      }
    } catch (err: any) {
      console.error("Error saving mappings:", err);
      setSaveError(createErrorState(err));
    }
  };

  // Handle smart mapping
  const handleSmartMapping = async () => {
    console.log("Smart Mapping");
    setSmartMappingLoading(true);
    setSmartMappingError(null);
    try {
      const mappingData = await ApiService.fetchSmartMapping();
      setEdges(createEdgesFromMapping(mappingData));
    } catch (err: any) {
      console.error("Error fetching smart mapping data:", err);
      setSmartMappingError(createErrorState(err));
    } finally {
      setSmartMappingLoading(false);
    }
  };

  // Dismissible hint tooltip
  const DeleteHint = () => {
    if (!showDeleteHint) return null;

    return (
      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          background: CONFIG.COLORS.background,
          color: CONFIG.COLORS.accent,
          padding: "12px 20px",
          borderRadius: "8px",
          border: `1px solid ${CONFIG.COLORS.accent}`,
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          gap: "10px",
          paddingTop: "20px",
        }}
      >
        <span>Tip: Click on any connection to remove it</span>
        <button
          onClick={() => setShowDeleteHint(false)}
          style={{
            background: "none",
            border: "none",
            color: CONFIG.COLORS.accent,
            cursor: "pointer",
            padding: "4px 8px",
          }}
        >
          ✕
        </button>
      </div>
    );
  };

  // Error state
  if (error) {
    return (
      <div style={{ padding: "20px", background: "#FFFFFF" }}>
        <Alert variant="danger" className="d-flex align-items-center">
          <FaTriangleExclamation className="me-3" size={24} />
          <div className="flex-grow-1">
            <h5 className="alert-heading mb-2">Mapping Error</h5>
            <p className="mb-2">{error.message}</p>
            {error.type === 'connection' && (
              <div className="small text-muted mb-3">
                <FaWifi className="me-1" />
                This usually indicates a network connectivity issue or the mapping service is temporarily unavailable.
              </div>
            )}
            <Button
              variant="outline-danger"
              size="sm"
              onClick={fetchData}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Retrying...
                </>
              ) : (
                <>
                  <MdRefresh className="me-1" />
                  Try Again
                </>
              )}
            </Button>
          </div>
        </Alert>
      </div>
    );
  }

  // Loading state
  if (loading) {
    return (
      <div style={{
        padding: "20px",
        background: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "400px"
      }}>
        <Spinner animation="border" role="status" className="mb-3" size="lg">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p style={{ color: CONFIG.COLORS.text, margin: 0 }}>Loading mapping data...</p>
      </div>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        height: "900px",
        background: "#FFFFFF",
        position: "relative",
      }}
    >
      <DeleteHint />
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        onEdgeClick={onEdgeClick}
        nodeTypes={nodeTypes}
        defaultEdgeOptions={{
          style: { stroke: CONFIG.COLORS.accent, strokeWidth: 2 },
          animated: true,
        }}
        defaultViewport={{ x: 0, y: 0, zoom: 1 }}
      >
        <Background color="#333" gap={20} size={1} />
        <Controls />
        <MiniMap
          style={{
            background: CONFIG.COLORS.background,
            border: `1px solid ${CONFIG.COLORS.accent}`,
          }}
          nodeColor={CONFIG.COLORS.accent}
        />
        <Panel position="top-left">
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <button onClick={refreshComponent}>Reset</button>
              <button
                onClick={handleSubmit}
                style={{
                  background: CONFIG.COLORS.background,
                  color: CONFIG.COLORS.accent,
                  padding: "10px 20px",
                  border: `1px solid ${CONFIG.COLORS.accent}`,
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                }}
              >
                Save Mappings
              </button>
              <button
                onClick={handleSmartMapping}
                disabled={smartMappingLoading}
                style={{
                  background: CONFIG.COLORS.background,
                  color: CONFIG.COLORS.accent,
                  padding: "10px 20px",
                  border: `1px solid ${CONFIG.COLORS.accent}`,
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                  opacity: smartMappingLoading ? 0.7 : 1,
                }}
              >
                {smartMappingLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginRight: "8px" }}
                    />
                    Mapping...
                  </>
                ) : (
                  "Smart Mapping"
                )}
              </button>
            </div>

            {/* Smart Mapping Error */}
            {smartMappingError && (
              <Alert variant="danger" style={{ margin: 0, padding: "8px 12px", fontSize: "12px" }}>
                <div className="d-flex align-items-center">
                  <FaTriangleExclamation size={16} className="me-2" />
                  <div>
                    <strong>Smart Mapping Error:</strong> {smartMappingError.message}
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={handleSmartMapping}
                      disabled={smartMappingLoading}
                      style={{ marginLeft: "8px", padding: "2px 8px", fontSize: "10px" }}
                    >
                      <MdRefresh size={12} />
                    </Button>
                  </div>
                </div>
              </Alert>
            )}

            {/* Save Error */}
            {saveError && (
              <Alert variant="danger" style={{ margin: 0, padding: "8px 12px", fontSize: "12px" }}>
                <div className="d-flex align-items-center">
                  <FaTriangleExclamation size={16} className="me-2" />
                  <div>
                    <strong>Save Error:</strong> {saveError.message}
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={handleSubmit}
                      style={{ marginLeft: "8px", padding: "2px 8px", fontSize: "10px" }}
                    >
                      <MdRefresh size={12} />
                    </Button>
                  </div>
                </div>
              </Alert>
            )}
          </div>
        </Panel>
      </ReactFlow>
    </div>
  );
};

const MappingComponent: React.FC<Props> = ({ name, type, age }) => {

  console.log(name)

  localStorage.setItem(
    "url3",
    "http://localhost:5050/api/SmartMapping/" + type
  );

  
  return (
    <ReactFlowProvider>
      <Flow name={name} type={type} age={age} />
    </ReactFlowProvider>
  );
};

export default MappingComponent;
